<template>
    <div style="border: 1px solid #ccc;">
        <Toolbar
		id="toolbar-container"
            style="border-bottom: 1px solid #ccc"
            :editor="editor"
            :defaultConfig="toolbarConfig"
            :mode="mode"
        />
        <Editor
            style="height: 500px; overflow-y: hidden;"
            v-model="html_"
            :defaultConfig="editorConfig"
            :mode="mode"
            @onCreated="onCreated"
			@onChange="onChangeEditor"
			
        />
    </div>
</template>

<script>
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import { DomEditor } from '@wangeditor/editor'

export default {
	name:"editors",
    components: { Editor, Toolbar },
	props: ['html_value'],
    data() {
        return {
            editor: null,
            // html: '<p>hello</p>',
			html: this.html_value, // 重新定义属性，避免报错
            toolbarConfig: { 
				excludeKeys: [ // 排除菜单组，写菜单组 key 的值即可
				'fullScreen', 
				"group-video"
				],
			},
            editorConfig: { 
				placeholder: '请输入内容...',
				MENU_CONF : {
				    fontSize: {
						fontSizeList: [
							'12px',
							'13px',
							'14px',
							'15px',
							'16px',
							'17px',
							'18px',
							'19px',
							'20px',
							'21px',
							'22px',
							'23px',
							'24px',
							'25px',
							'26px',
							'27px',
							'28px',
							'29px',
							'30px',
							'31px',
							'32px',
							'33px',
							'34px',
							'35px',
							'36px',
							'37px',
							'38px',
							'39px',
							'40px',
							'41px',
							'42px',
							'43px',
							'44px',
							'45px',
							'46px',
							'47px',
							'48px',
							'49px',
							'50px',
						]
					},
					lineHeight: {
						lineHeightList: ['1', '1.5','1.6','1.7','1.8','1.9','2','2.1','2.2','2.3','2.4','2.5','2.6','2.7','2.8','2.9','3']
					},
					// uploadImage: {
					// 	// 自定义上传
					// 	// async customUpload(file: File, insertFn: InsertFnType) {  // TS 语法
					// 	async customUpload(files, insertFn) {  // JS 语法
					// 		console.log("customUpload",files);
							
					// 		var params = new FormData()
					// 		params.append('file', files)
					// 		params.append('type', 5)
							
					// 		// file 即选中的文件
					// 		// 自己实现上传，并得到图片 url alt href
					// 		landAddUploadImage(params).then(res=>{
					// 			console.log("微信图文消息",res);
								
					// 			// 最后插入图片。这是wangEditor富文本自己的方法
					// 			insertFn(res.data.data.url, '', '')
					// 		})
							
					// 	}
					// }
				},
			},
            mode: 'default', // or 'simple'
        }
    },
	computed: {
	    html_: {
	        get() {
	          return this.html_value;
	        },
	        set(val) {
	          //grants_改变由父组件控制
	          this.$emit("change_editor", val);
	        }
	    }
	},
    methods: {
		// 阻止默认的粘贴行为。保证样式也能复制过来
		customPaste(editor, event, callback) { // JS 语法
			// console.log();
		    // event 是 ClipboardEvent 类型，可以拿到粘贴的数据
		    // 可参考 https://developer.mozilla.org/zh-CN/docs/Web/API/ClipboardEvent
			
		    const html = event.clipboardData.getData('text/html') // 获取粘贴的 html
		    // const text = event.clipboardData.getData('text/plain') // 获取粘贴的纯文本
		    // const rtf = event.clipboardData.getData('text/rtf') // 获取 rtf 数据（如从 word wsp 复制粘贴）
			console.log("html",html);
			
		    // 同步
		    // editor.insertText(html)
			this.html_ = html
		    // 异步
		    // setTimeout(() => {
		    //     editor.insertText('yy')
		    // }, 1000)
		
		    // 阻止默认的粘贴行为
		    event.preventDefault()
		    callback(false) // 返回值（注意，vue 事件的返回值，不能用 return）
		    
		    // 返回 true ，继续默认的粘贴行为
		    // callback(true)
		},
        onCreated(editor) {
            this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
        },
		onMounted(){
		},
		// 有了html_计算属性，就不需要这里了
		onChangeEditor(e){
			
			// e.children[0].children[0].text 可以看里面输入的值。但是不是<p>aa<p>这种html格式的。所以要直接返回this.html
			// this.$emit('change_editor', this.html)
		},
    },
    mounted() {
        // 模拟 ajax 请求，异步渲染编辑器
  //       setTimeout(() => {
		// 	// const toolbar = DomEditor.getToolbar(this.editor)
		// 	    this.html = '<p>模拟 Ajax 异步设置内容 HTML</p>'
		// 	// console.log("toolbar", toolbar.getConfig().toolbarKeys) // 获取工具列表，用于找出哪些是不要的，然后在上面的配置里填上，就不会出现了。
		
  //       }, 1500)
  
		
    },
    beforeDestroy() {
        const editor = this.editor
        if (editor == null) return
        editor.destroy() // 组件销毁时，及时销毁编辑器
    }
}
</script>

<style scoped>

</style>